import "../../Subbundle.css";
import "./BinarySearch.css";
import React from "react";
import { Link } from "react-router-dom";

let gif1 =
	"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fd18l82el6cdm1i.cloudfront.net%2Fuploads%2FbePceUMnSG-binary_search_gif.gif&f=1&nofb=1";
let code1 =
	"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fi2.wp.com%2Ftechieme.in%2Fwp-content%2Fuploads%2F2013%2F08%2Fbinarysearch.jpg&f=1&nofb=1";

export default class BinarySearch extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
		document.title = "Binary Search | Searching Bundle";
	}

	render() {
		return (
			<main>
				<h1
					style={{
						textAlign: "center",
						fontFamily: "Gilroy",
						textDecoration: "underline",
						fontSize: "2rem",
					}}
				>
					<Link to="/">Go to Home</Link>
				</h1>
				<div className="subbundle-main">
					<h1>Binary Search</h1>
					<p>
						<b>Binary search</b> is a type of searching algorithm
						that uses the logarithmic approach in searching an
						element, generally in an array. It finds the desired
						element by dividing the array into sub-arrays, by
						halving the structure until and unless we find the
						element.
					</p>
					<p>
						It has a complexity of <code>O(log(n))</code>, which
						means it follows a logarithmic approach, by dividing N
						elements, into N/2, N/4, N/8 and so on...
					</p>
					<p>
						This kind of search algorithm works best for data
						structures with a lot of elements. But there is a little
						requirement before we can use binary search. The array
						needs to be <b>sorted by order</b>.
					</p>
					<img id="bs-gif1" src={gif1} />
					<span>Binary Search Animation</span>
					<p>
						Since this search uses the log approach, there is only
						one way to find the element. After the array is sorted,
						we choose the central pivot element. And then if our
						desired element is greater than the pivot element, we go
						right; and vice-versa.
					</p>
					<img
						id="ls-code1"
						src={code1}
						title="Iterative Linear Search"
					/>
					<span>Binary Search Pseudocode</span>
					<br />
					<p>
						In the above pseudocode, <code>mid</code> is our pivot
						element. We use <code>mid</code> to determine where our
						desired element will be found in the data structure. Now
						if you observe in the GIF given in this webpage, we want
						to find the number 47.
					</p>
					<p>
						Now if we used linear search, it would take{" "}
						<b>8 tries</b> at most to find 47, but binary search
						does the trick in only <b>3 tries.</b>
					</p>

					<hr />
					<h1>GAME TIME!</h1>
					<div className="subbundle-game-container">
						<h1
							style={{
								textAlign: "center",
								fontFamily: "Poppins",
							}}
						>
							GAME COMING SOON!
						</h1>
					</div>
					<div className="next-previous-div">
						<Link to="/games/searching/linear">
							<span>
								{"<"}Prev <b>Linear Search</b>
							</span>
						</Link>
					</div>
				</div>
			</main>
		);
	}
}
